/* eslint-disable no-unused-vars */
import { useMemo, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ChooseAppsBtn from '../chooseAppsBtn/ChooseAppsBtn';
import { selectTargettingErrorFlag } from 'store/selectors';
import { generalActions, targetingPlacementsActions } from 'store/actions';
import SelectedItem from './SelectedItem';
import { Buttons, ErrorForBtn } from 'components';
import { alphabeticallySort } from 'utils';
import * as S from './SelectedApps.styled';

const SelectedApps = ({ isAllPlacementsDisabled }) => {
  const dispatch = useDispatch();

  const errorFlag = useSelector(selectTargettingErrorFlag);

  const current_selected_apps = useSelector(
    (store) => store?.general?.mainCampaignObject?.currently_selected_apps,
  );
  const selectedAppsNumbers = useMemo(
    () => current_selected_apps?.map(({ pba_number }) => pba_number),
    [current_selected_apps],
  );

  const clearAllBtnClick = () => {
    dispatch(generalActions.clear_currently_selected_apps());
  };

  useEffect(() => {
    selectedAppsNumbers &&
      dispatch(
        targetingPlacementsActions.updateErrorField({ errorField: 'placements', newValue: false }),
      );
    return () => {
      dispatch(
        targetingPlacementsActions.updateErrorField({ errorField: 'placements', newValue: false }),
      );
    };
  }, [selectedAppsNumbers]);

  const errText = `Please choose Apps${
    !isAllPlacementsDisabled ? ' or select "All Placements"' : ''
  }.`;

  return (
    <>
      <S.MultipleItemsSelectionComponent showBorder={errorFlag.placements}>
        <S.FlexColumn3>
          <ChooseAppsBtn />
        </S.FlexColumn3>
        {selectedAppsNumbers?.length ? (
          <>
            <S.Separator />
            <S.SelectedItems>
              <Buttons.TertiarySmall
                style={{ marginLeft: 'auto' }}
                id='choose_apps_clear_all'
                onClick={clearAllBtnClick}
              >
                Clear All
              </Buttons.TertiarySmall>
              <S.SelectedItemsList>
                {[...current_selected_apps]?.sort(alphabeticallySort('pba_name'))?.map((app) => {
                  return <SelectedItem key={app.pba_number} {...app} />;
                })}
              </S.SelectedItemsList>
            </S.SelectedItems>
          </>
        ) : null}
      </S.MultipleItemsSelectionComponent>
      <ErrorForBtn errorMsg={errText} isOpen={errorFlag.placements} />
    </>
  );
};

export default SelectedApps;
